<template>
  <UAccordion
    open-icon="i-lucide-chevron-down"
    close-icon="i-lucide-chevron-up"
    variant="solid"
    color="neutral"
    :ui="{
      // item: 'w-full max-w-full text-black text-base bg-white pt-2 pb-8',
      // body: 'text-sm pt-2 pb-8',
      label: 'text-lg text-start break-words',
      content: 'data-[state=open]:animate-[accordion-down_200ms_ease-out] data-[state=closed]:animate-[accordion-up_200ms_ease-out] overflow-hidden focus:outline-none pt-2 pb-8',
      // icon: 'ms-auto transform transition-transform duration-200 flex-shrink-0',
    }"
    :items="[
      {
        label: t('comps.write_guide.tips'),
        icon: 'i-lucide-align-left',
        slot: 'tips',
      },
      {
        label: t('comps.write_guide.examples'),
        icon: 'i-lucide-message-circle-more',
        slot: 'examples',
      },
      {
        label: t('comps.write_guide.why'),
        icon: 'i-lucide-message-circle-question',
        slot: 'why',
      },
    ]"
  >
    <template #tips>
      <ul class="flex flex-col gap-2 md:px-8 pl-4 rounded-sm text-lg list-disc list-inside">
        <li
          v-for="(tip, index) in message_examples.tips"
          :key="'tip'+index"
        >
          {{ tip }}
        </li>
      </ul>
    </template>
    <template #examples>
      <ActionMessageExamples
        :emails="message_examples.emails"
        :messages="message_examples.messages"
      />
    </template>
    <template #why>
      <p
        class="md:px-8 text-base"
        v-html="t('comps.write_guide.why_text')"
      />
    </template>
  </UAccordion>
</template>

<script setup lang="ts">
const { message_examples } = getData()
</script>
